import React from 'react';

import { FormattedMessage } from 'react-intl';

import { INSURANCE } from '../../../../../filters/constants';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import messages from './messages';

export default {
  id: INSURANCE,
  displayName: <FormattedMessage {...messages.insurance} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK,
  filterValue: 'InsuranceProviderId',
  allowsMultipleSelection: true,
  expectsArgumentAsArray: true,
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK, criteriaInformations, existingFiltersHelpers);
  },
};
